import { NameDto } from '../Common/Types'

export interface LandingPageDto {
  id: string
  name: string | null
  promoMaterialBaseUrl: NameDto | null
  url: string | null
  enabled: boolean
  endDateTime: string | null
  readOnly: boolean
  imagePath: string | null
  tickmillCompany: NameDto | null
  languages: NameDto<string>[] | null
  order: number
  isDefault: boolean
  promoMaterials: PromoMaterialDto[] | null
}

interface PromoMaterialDto {
  id: string
  name: string | null
  enabled: boolean
  promoMaterialSize: NameDto
  promoMaterialCategory: NameDto
  promoMaterialType: NameDto
  landingPage: LandingPageDto | null
  imagePath: string | null
  tickmillCompany: NameDto
  language: NameDto<string>
}

export enum IBLandingPageKey {
  name = 'name',
  language = 'languages.name',
  baseURL = 'promoMaterialBaseUrl.id',
  path = 'url',
  image = 'Image',
  entity = 'tickmillCompany.name',
  active = 'tickmillCompany.enabled',
  endDate = 'endDateTime',
  updatedDate = 'updatedDate',
}

export enum IBLandingPageFilterKey {
  name = 'Name',
  promoMaterialBaseUrlId = 'PromoMaterialBaseUrlId',
  url = 'Url',
  enabled = 'Enabled',
  dateUpdated = 'DateUpdated',
  endDateTime = 'EndDateTime',
  tickmillCompanyId = 'TickmillCompanyId',
  languageId = 'LanguageId',
  imagePath = 'ImagePath',
}
